<template>
  <div class="select-card-cell">
    <van-field
        :label="label"
        :required="true"
        readonly
        :clickable="editor"
    >
      <template #input>
        <div class="content">
          <div v-for="(item, idx) in columns" :key="idx" @click="onSelect(item, idx)"
               :class="['select', index==idx?'active': '']">
            {{ item }}
          </div>
        </div>
      </template>
    </van-field>
    <!--      <div class="label">{{label}}</div>-->
    <!--      <div v-for="(item, idx) in columns" :key="idx" @click="onSelect(item, idx)"-->
    <!--           :class="['select', index==idx?'active': '']">-->
    <!--        {{item}}-->
    <!--      </div>-->
    <!--    </div>-->
    <van-field v-model="index" :name="name" v-show="false"/>
  </div>
</template>

<script>
export default {
  name: "cardSelectFormCell",
  props: ['label', 'name', 'initValue', 'columns', 'editor'],
  data() {
    return {
      index: this.initValue
    }
  },
  watch: {
    initValue(newValue, oldValue) {
      console.log('initValue => newValue ', newValue)
      this.index = newValue
    }
  },
  methods: {
    onSelect(item, index) {
      if (this.editor === false) {
        return
      }
      this.index = index
      this.$emit('change', index)
      console.log('onSelect => onSelect ', item, index)
    }
  }
}
</script>

<style lang="less">
.select-card-cell {
  .van-field__label {
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }
  .van-cell {
    padding: 10px 16px 10px 22px !important;
  }
  .van-cell--required::before {
    left: 14px !important;
  }
}
</style>

<style scoped lang="less">
.select-card-cell {
  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .label {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }
  .select {
    margin-left: 8px;
    background: gray;
    //margin-right: 20px;
    width: 80px;
    height: 27px;
    line-height: 27px;
    background: #EDEDED;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 400;
    color: #3F403F;
    text-align: center;
  }
  .active {
    color: #FFFFFF;
    background: #3D8AFF;

  }
}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/cardSelectFormCell.vue